var turboFrameProgressLoadingInterval = undefined;

function hideProgress() {
  clearInterval(turboFrameProgressLoadingInterval);
  let progressBar = document.querySelector('.turbo-progress-bar');

  !!progressBar && progressBar.remove();
}

[
  "turbo:frame-render",
  "turbo:frame-load",
  "turbo:frame-missing",
  "turbo:render",
  "turbo:submit-end",
  "turbo:fetch-request-error"
].forEach((event) => document.addEventListener(event, hideProgress) );

document.addEventListener("turbo:before-fetch-request", () => {
  let progressBar = document.querySelector('.turbo-progress-bar');

  if (!progressBar) {
    document.querySelector('body').insertAdjacentHTML('beforeend', '<div class="turbo-progress-bar"></div>');
    progressBar = document.querySelector('.turbo-progress-bar');
  }

  progressBar.style.opacity = 1;
  let currentProgress = 120;
  turboFrameProgressLoadingInterval = setInterval(() => {
    progressBar.style.width = `${(currentProgress += currentProgress) / 30}%`;
  }, 450);
});

document.addEventListener("turbo:load", () => {
  $(document.body).on('click', '[data-turbo-frame-target]', (ev) => {
    let $el = ev.currentTarget,
      frame = document.querySelector($el.dataset.turboFrameTarget);

    if (!frame)
      return;

    frame.setAttribute('src', $el.dataset.frameSrc || $el.getAttribute('href'));
  })
});